module.exports = __webpack_public_path__ + "media/ש.8df3bdb5.mp3";